/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "../../axios";

export default {
  async login({ dispatch }, credentials) {
    let response = await axios.post("/api/auth/login", {
      email: credentials.email,
      password: credentials.password,
    });
    console.log(response);
    return dispatch("attempt", response.data.token);
  },

  async attempt({ commit }, token) {
    try {
      if (token) {
        // Decode JWT to check expiry and get user name
        try {
          const payload = JSON.parse(atob(token.split(".")[1]));
          if (payload.exp && payload.exp * 1000 < Date.now()) {
            // Token expired
            commit("SET_TOKEN", null);
            return;
          }
          commit("SET_TOKEN", token);
          if (payload.name) {
            commit(
              "UPDATE_USER_INFO",
              { displayName: payload.name },
              { root: true },
            );
          }
        } catch (e) {
          commit("SET_TOKEN", null);
        }
      }
    } catch (error) {
      console.log(error);
      commit("SET_TOKEN", null);
    }
  },

  logout({ commit }) {
    sessionStorage.clear();
    commit("SET_TOKEN", null);
  },
};
